export enum BloodGroupEnum {
    A_POSITIVE = "A+",
    O_POSITIVE = "O+",
    B_POSITIVE = "B+",
    AB_POSITIVE = "AB+",
    A_NEGATIVE = "A-",
    B_NEGATIVE = "B-",
    O_NEGATIVE = "O-",
    AB_NEGATIVE = "AB-",
}